import React from 'react';

export const PeopleSceneContext = React.createContext({});
